/**
 * Customer-facing names for the two SBC as a Service variants.
 *
 * "SRT" is the internal name for the modern service — it stays in endpoints,
 * service types and code, but means nothing to a customer, so every
 * user-visible surface renders these labels instead.
 */
export const SBCAAS_CLASSIC_LABEL = 'SBCaaS (Classic)';
export const SBCAAS_MODERN_LABEL = 'SBCaaS (Modern)';
